import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  gap: 2px;
`;

export default Container;
